"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuiltForMo() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: signatureRef,
    isVisible: isSignatureVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const paragraphs = [{
    id: 1,
    text: "In our search for healing, we navigated a fragmented healthcare system, seeking therapies that didn't just treat symptoms, but actively restored vitality. We discovered the transformative power of integrative wellness—targeted IV therapies, precise lab testing, and holistic recovery methods."
  }, {
    id: 2,
    text: "But finding these treatments in one cohesive, supportive, and elevated environment was nearly impossible. We spent countless hours piecing together a protocol that worked, realizing along the way that true wellness shouldn't be this difficult to access."
  }, {
    id: 3,
    text: "We knew there had to be a better way. A place where medical precision meets compassionate, luxurious care. MO Protocol is the culmination of that journey. Built from our family's deepest need, designed meticulously for your optimal health."
  }];
  return <section id="builtformo" className="bg-background relative overflow-hidden py-32 md:py-48 lg:py-56">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-[var(--color-gold-accent)]/5 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-[var(--color-green-accent)]/5 blur-[120px]" />
      </div>
      
      <div className="container relative z-10 mx-auto px-6 md:px-8">
        <div className="mx-auto max-w-4xl">
          
          {}
          <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <Badge variant="outline" className="mb-10 border-[var(--color-gold-accent)]/20 bg-transparent text-[var(--color-gold-accent)] uppercase tracking-[0.4em] px-6 py-1.5 rounded-full text-[10px] font-semibold">
              Our Origin
            </Badge>
            
            <h2 className="font-default text-5xl font-normal tracking-tight text-foreground md:text-6xl lg:text-7xl mb-12 leading-[1.1]">
              Built for <span className="italic text-[var(--color-gold-accent)]">Mo</span>
            </h2>
            
            <div className="flex justify-center mb-20">
              <Separator className="w-24 h-[1px] bg-[var(--color-gold-accent)]/30" />
            </div>
          </div>

          {}
          <div ref={contentRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 transition-all delay-300 duration-1000 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="lg:col-span-5">
              <p className="font-default text-2xl md:text-3xl lg:text-4xl font-light leading-tight text-foreground/90 italic">
                "It began with a diagnosis that shifted our entire world. A moment of profound uncertainty that demanded answers beyond the conventional."
              </p>
            </div>
            
            <div className="lg:col-span-7 space-y-10">
              {paragraphs.map((p, i) => <p key={p.id} data-index={i} className="text-lg leading-relaxed text-muted-foreground font-light">
                  {p.text}
                </p>)}
            </div>
          </div>

          {}
          <div ref={signatureRef} className={`mt-24 md:mt-32 text-center transition-all delay-500 duration-1000 ease-out ${isSignatureVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="inline-block p-8 md:p-12 rounded-2xl bg-card/30 backdrop-blur-sm border border-border/40 shadow-sm">
              <div className="flex flex-col items-center justify-center space-y-6">
                <span className="font-default text-2xl md:text-3xl italic text-foreground/80">
                  We created the sanctuary we once sought.
                </span>
                <div className="flex items-center gap-4 w-full">
                  <Separator className="flex-1 bg-border/30" />
                  <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--color-gold-accent)] whitespace-nowrap">
                    The MO Protocol Family
                  </span>
                  <Separator className="flex-1 bg-border/30" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}